/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useDepositStore = defineStore("deposit", {
  actions: {
    async listDepositFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          groupUid: payload.groupUid,
          shopUid: payload.shopUid,
          cusUid: payload.cusUid,
          refNumber: payload.refNumber,
          tkRefNumber: payload.tkRefNumber,
          channel: payload.channel, //SHOP, LINE_ADS
          txDate: payload.txDate, // 1-31
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-rpt-svc/deposit/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async infoFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/deposit/info/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async searchFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          cusUid: payload.cusUid,
          refNumber: payload.refNumber,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/deposit/search";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async depositAddFetch(payload) {
      const body = {
        workCaseUid: payload.workCaseUid, // always required
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/deposit/newDeposit";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async withdrawAddFetch(payload) {
      const body = {
        uids: payload.uids, // always required
        withdrawerUid: payload.withdrawerUid,
        withdrawerName: payload.withdrawerName,
        fpImageUid: payload.fpImageUid,
        fpTemplateUid: payload.fpTemplateUid,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/deposit/newWithdraw";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async historyFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          groupUid: payload.groupUid,
          shopUid: payload.shopUid,
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          cusUid: payload.cusUid,
          refNumber: payload.refNumber,
          tkRefNumber: payload.tkRefNumber,
          channel: payload.channel, //SHOP, LINE_ADS
          type: payload.type, // DEPOSIT, WITHDRAW,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-rpt-svc/deposit/history";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
